import React, { createRef } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Form, Button } from 'react-bootstrap';
import SelectDate from '../../component/SelectDate';

import PageBar from '../../component/PageBar';
import { GetList, UpdateAll, DeleteArray, Crawling, GetListDownload } from './http';
import { GetList as GetListBranch } from '../branch/http';
import { GetList as GetListDriver } from '../driver/http';
import moment from 'moment';
import { CircleSpinner } from 'react-spinners-kit';

import ReactToPrint from 'react-to-print';
import PrintBill from '../../print/bill';
import download from 'downloadjs';

class List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            search: {
                page: 1,
                size: 30,
                sort: 'inspct_instt_nm|manager1Id|inspct_dt',
                status: 'OPENED',
                type: '',
                branchId: '',
                driverId: '',
                buld_nm: '',
                inspct_dt: [undefined, undefined],
            },
            branch: [],
            driver: [],
            totalPages: 20,
            crawling: false,
            crawlingDate: [moment().format('YYYY-MM-DD'), moment().add(1, 'd').format('YYYY-MM-DD')],
        };
        this.printBill = createRef();
        this.printBill2 = createRef();

        this.role = localStorage.getItem('role', '');

        this.state.search.inspct_dt[0] = moment().format('YYYY-MM-DD 00:00:00');
        this.state.search.inspct_dt[1] = moment().add(7, 'days').format('YYYY-MM-DD 23:59:59');

        const params = sessionStorage.getItem('batcha_list_search');
        if (params) {
            this.state.search = JSON.parse(params);
            if (this.state.search.inspct_dt[0] === 'Invalid date' || this.state.search.inspct_dt[1] === 'Invalid date') {
                this.state.search.inspct_dt[0] = moment().format('YYYY-MM-DD 00:00:00');
                this.state.search.inspct_dt[1] = moment().add(7, 'days').format('YYYY-MM-DD 23:59:59');
            }
        }

        GetListBranch(this, { role: 'BRANCH', status: 'OPENED', sort: 'title' }, res => {
            const rows = res.rows.map(x => {
                return { idx: x.id, title: x.title, price: x.price };
            });
            rows.unshift({ idx: '', title: '본사배차관리선택', price: 0 });

            this.setState({
                branch: rows,
            });
        });

        GetListDriver(
            this,
            {
                page: 1,
                size: 1000,
                sort: 'name',
                status: 'OPENED',
            },
            res => {
                const rows = res.rows.map(x => {
                    return { idx: x.id, title: x.name, branchId: x.branchId };
                });
                rows.unshift({ idx: '', title: '기사관리선택' });

                this.setState({
                    driver: rows,
                });
            },
        );

        this.reloadList(1);
    }

    clickCrawling = e => {
        this.setState({ crawling: true });
        Crawling(this, this.state.crawlingDate[0], this.state.crawlingDate[1], res => {
            alert('수집이 완료 되었습니다.');
            this.setState({ crawling: false });
            this.reloadList(1);
        });
    };

    reloadList = page => {
        const params = this.state.search;
        params.page = page;
        sessionStorage.setItem('batcha_list_search', JSON.stringify(params));

        this.setState({
            search: params,
        });

        GetList(this, params, this.resultList.bind(this));
    };

    /**
     * 리스트
     */
    resultList = response => {
        response.rows.map(x => (x.check = false));
        this.setState({
            items: response.rows,
            totalPages: Math.ceil(response.range.total / response.range.size),
        });
    };

    /**
     * 삭제
     * @param {*} item
     */
    clickDelete = e => {
        // const data = this.state.items.filter(x => x.check && x.complete === 'N').map(x => x.id);
        const data = this.state.items.filter(x => x.check).map(x => x.id);
        if (data.length === 0) {
            return;
        }

        if (window.confirm('삭제 하시겠습니까?')) {
            DeleteArray(this, data, res => {
                alert('삭제가 완료 되었습니다.');
                this.reloadList(this.state.search.page);
            });
        }
    };

    /**
     * 취소
     * @param {*} item
     */
    clickCancel = e => {
        const data = this.state.items
            // .filter(x => x.check && x.complete === 'N')
            .filter(x => x.check)
            .map(x => {
                return { id: x.id, branchId: 0, driverId: 0 };
            });
        if (data.length === 0) {
            return;
        }

        if (window.confirm('취소 하시겠습니까?')) {
            UpdateAll(this, data, res => {
                alert('취소가 완료 되었습니다.');
                this.reloadList(this.state.search.page);
            });
        }
    };

    /**
     * 수량 선택
     * @param {*} num
     * @returns
     */
    selectNumber = x => {
        let array = [];
        for (var i = 0; i <= 10; i++) {
            array.push(
                <option value={i} key={i}>
                    {i}
                </option>,
            );
        }

        return (
            <Form.Control
                as="select"
                onChange={e => {
                    x.recptn_cnt = e.target.value;

                    const branch = this.state.branch.find(b => b.idx == x.branchId);

                    // x.price = branch.price * x.recptn_cnt;
                    // x.branchPrice = branch.price * x.recptn_cnt;
                    // x.driverPrice = branch.price * x.recptn_cnt;
                    x.price = branch.price;
                    x.branchPrice = branch.price;
                    x.driverPrice = branch.price;
                    x.confirmDriver = 'N';

                    this.setState({});

                    UpdateAll(this, [
                        {
                            id: x.id,
                            recptn_cnt: x.recptn_cnt,
                            // price: branch.price * x.recptn_cnt,
                            // branchPrice: branch.price * x.recptn_cnt,
                            // driverPrice: branch.price * x.recptn_cnt,
                            price: branch.price,
                            branchPrice: branch.price,
                            driverPrice: branch.price,
                        },
                    ]);
                }}
                value={x.recptn_cnt}
            >
                {array}
            </Form.Control>
        );
    };

    /**
     * 지사 선택
     * @param {*} array
     * @param {*} value
     */
    selectorBranch = x => {
        const { branch } = this.state;

        return (
            <Form.Control
                as="select"
                onChange={e => {
                    x.branchId = e.target.value;

                    const branch = this.state.branch.find(b => b.idx == x.branchId);

                    // x.price = branch.price * x.recptn_cnt;
                    // x.branchPrice = branch.price * x.recptn_cnt;
                    // x.driverPrice = branch.price * x.recptn_cnt;
                    x.price = branch.price;
                    x.branchPrice = branch.price;
                    x.driverPrice = branch.price;
                    x.confirmDriver = 'N';
                    x.complete = 'N';

                    this.setState({ data: x });

                    UpdateAll(this, [
                        {
                            id: x.id,
                            branchId: x.branchId === '' ? 0 : x.branchId,
                            confirmDriver: 'N',
                            price: branch.price,
                            branchPrice: branch.price,
                            driverPrice: branch.price,
                        },
                    ]);
                }}
                value={x.branchId}
                // disabled={x.complete === 'Y'}
            >
                {branch.map(x => (
                    <option value={x.idx}>{x.title}</option>
                ))}
            </Form.Control>
        );
    };

    /**
     * 기사 선택
     * @param {*} array
     * @param {*} value
     */
    selectorDriver = x => {
        let { driver } = this.state;

        const array = driver.filter(d => d.branchId == x.branchId);
        array.unshift({ idx: '', title: '본사배차관리선택' });

        return (
            <Form.Control
                as="select"
                onChange={e => {
                    x.driverId = e.target.value;
                    x.confirmDriver = 'N';
                    x.complete = 'N';
                    this.setState({ data: x });
                    UpdateAll(this, [{ id: x.id, driverId: x.driverId === '' ? 0 : x.driverId, confirmDriver: 'N' }]);
                }}
                value={x.driverId}
                // disabled={x.complete === 'Y'}
            >
                {array.map(x => (
                    <option value={x.idx}>{x.title}</option>
                ))}
            </Form.Control>
        );
    };

    /**
     * 결제 선택
     * @param {*} array
     * @param {*} value
     */
    selectorPay = x => {
        return (
            <Form.Control
                as="select"
                onChange={e => {
                    x.pay = e.target.value;
                    this.setState({ data: x });
                    UpdateAll(this, [{ id: x.id, pay: x.pay }]);
                }}
                value={x.pay}
            >
                <option value={'Y'}>{'Y'}</option>
                <option value={'N'}>{'N'}</option>
            </Form.Control>
        );
    };

    /**
     *
     * @param {*} array
     * @param {*} value
     */
    selector = (array, key, value) => {
        const { data } = this.state;

        return (
            <Form.Control
                as="select"
                onChange={e => {
                    data[key] = e.target.value;
                    this.setState({ data });
                }}
                value={value}
            >
                {array.map(x => (
                    <option value={x.idx}>{x.title}</option>
                ))}
            </Form.Control>
        );
    };

    selectorSearchDriver = () => {
        let { search, driver } = this.state;

        const array = driver.filter(d => (search.branchId ? search.branchId == d.branchId : true));
        array.unshift({ idx: '', title: '기사선택' });

        return (
            <Form.Control
                as="select"
                onChange={e => {
                    search.driverId = e.target.value;
                    this.setState({ search });
                }}
                value={search.driverId}
                // disabled={x.complete === 'Y'}
            >
                {array.map(x => (
                    <option value={x.idx}>{x.title}</option>
                ))}
            </Form.Control>
        );
    };

    render() {
        const { items, search, branch, crawling } = this.state;

        const itemsCheck = items.filter(x => x.check);

        return (
            <div>
                <Row>
                    <Col>
                        <div className="board_top_box">
                            <div className="lb">
                                <Form.Control
                                    as="select"
                                    onChange={e => {
                                        search.type = e.target.value;
                                        search.branchId = '';
                                        search.driverId = '';
                                        this.setState({ search });
                                    }}
                                    value={search.type}
                                >
                                    <option value={''}>민원24배차관리선택</option>
                                    <option value={'1'}>민원24</option>
                                    <option value={'2'}>한국분동</option>
                                </Form.Control>

                                {this.role === 'ADMIN' && (
                                    <Form.Control
                                        as="select"
                                        onChange={e => {
                                            search.branchId = e.target.value;
                                            search.driverId = '';
                                            this.setState({ search });
                                        }}
                                        value={search.branchId}
                                    >
                                        {/* <option value={''}>본사배차관리선택</option> */}
                                        {branch.map(x => (
                                            <option value={x.idx}>{x.title}</option>
                                        ))}
                                    </Form.Control>
                                )}
                                {this.role === 'ADMIN' && this.selectorSearchDriver()}
                                <div className="gab-w-10"></div>

                                <SelectDate
                                    title=""
                                    value={''}
                                    from={search.inspct_dt[0]}
                                    to={search.inspct_dt[1]}
                                    onChange={(from, to) => {
                                        search.inspct_dt[0] = moment(from, 'YYYY.MM.DD').format('YYYY-MM-DD 00:00:00');
                                        search.inspct_dt[1] = moment(to, 'YYYY.MM.DD').format('YYYY-MM-DD 23:59:59');
                                        this.setState(search);
                                    }}
                                />

                                <div className="gab-w-10"></div>

                                <div className="search_box_2">
                                    <input
                                        placeholder="검색어를 입력하세요."
                                        type="text"
                                        class="form-control search01"
                                        onChange={e => {
                                            search.buld_nm = e.target.value;
                                            this.setState({ search });
                                        }}
                                        onKeyPress={e => {
                                            if (e.key === 'Enter') {
                                                this.reloadList(1);
                                            }
                                        }}
                                    />
                                    <button class="btn_01 deep" onClick={e => this.reloadList(1)}>
                                        검색
                                    </button>
                                </div>
                            </div>

                            <div className="rb">
                                {this.role === 'ADMIN' && (
                                    <SelectDate
                                        title=""
                                        value={''}
                                        align="right"
                                        from={this.state.crawlingDate[0]}
                                        to={this.state.crawlingDate[1]}
                                        onChange={(from, to) => {
                                            const { crawlingDate } = this.state;
                                            crawlingDate[0] = moment(from).format('YYYY-MM-DD');
                                            crawlingDate[1] = moment(to).format('YYYY-MM-DD');
                                            this.setState(crawlingDate);
                                        }}
                                    />
                                )}
                                {this.role === 'ADMIN' && (
                                    <button type="button" className="btn_02 red" onClick={this.clickCrawling}>
                                        {crawling ? <CircleSpinner size={20} color="#fff" loading={crawling} /> : '배차불러오기'}
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* 법인사업자 */}
                        <Card style={{ display: 'none' }}>
                            <div ref={this.printBill}>
                                {itemsCheck.map(x => (
                                    <PrintBill data={x} type={1} />
                                ))}

                                {itemsCheck.length === 0 && <div style={{ textAlign: 'center', padding: 40 }}>데이터를 선택해주세요.</div>}
                            </div>
                        </Card>

                        {/* 일반사업자 */}
                        <Card style={{ display: 'none' }}>
                            <div ref={this.printBill2}>
                                {itemsCheck.map(x => (
                                    <PrintBill data={x} type={2} />
                                ))}

                                {itemsCheck.length === 0 && <div style={{ textAlign: 'center', padding: 40 }}>데이터를 선택해주세요.</div>}
                            </div>
                        </Card>

                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">배차관리 목록</Card.Title>
                                <div className="rb">
                                    <table className="tbl_board info">
                                        <colgroup>
                                            <col width="10" />
                                            <col width="60" />
                                            <col width="10" />
                                            <col width="70" />
                                            <col width="10" />
                                            <col width="70" />
                                            <col width="10" />
                                            <col width="70" />
                                        </colgroup>
                                        <tr>
                                            {/* <td className="bgGray">미배차</td>
                                            <td className="bgGreen">기사배차</td>
                                            <td className="bgBlue">기사확인</td>
                                            <td className="bgBlack">완료</td> */}
                                            <td className="bgGray"></td>
                                            <td>미배차</td>
                                            <td className="bgGreen"></td>
                                            <td>기사배차</td>
                                            <td className="bgBlue"></td>
                                            <td>기사확인</td>
                                            <td className="bgBlack"></td>
                                            <td>운송완료</td>
                                        </tr>
                                    </table>
                                    <button
                                        type="button"
                                        className="btn_01 b_excel"
                                        onClick={e => {
                                            const params = this.state.search;

                                            GetListDownload(this, params, res => {
                                                download(atob(res), 'batchalist.xlsx', {
                                                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                                });
                                            });
                                        }}
                                    >
                                        엑셀다운로드
                                    </button>
                                    <ReactToPrint
                                        trigger={() => {
                                            // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                                            // to the root node of the returned component as it will be overwritten.
                                            return (
                                                <button type="button" className="btn_02">
                                                    법인사업자 견적서출력
                                                </button>
                                            );
                                        }}
                                        content={() => this.printBill.current}
                                    />

                                    <ReactToPrint
                                        trigger={() => {
                                            // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                                            // to the root node of the returned component as it will be overwritten.
                                            return (
                                                <button type="button" className="btn_02">
                                                    일반사업자 견적서출력
                                                </button>
                                            );
                                        }}
                                        content={() => this.printBill2.current}
                                    />

                                    {/* <button type="button" className="btn_02">
                                        일반사업자 견적서출력
                                    </button> */}
                                    {this.role === 'ADMIN' && (
                                        <button
                                            type="button"
                                            className="btn_02"
                                            onClick={e => {
                                                window.location = '/a/batcha/edit';
                                            }}
                                        >
                                            배차생성
                                        </button>
                                    )}
                                    {this.role === 'ADMIN' && (
                                        <button type="button" className="btn_02" onClick={this.clickDelete}>
                                            배차삭제
                                        </button>
                                    )}
                                    {this.role === 'ADMIN' && (
                                        <button type="button" className="btn_02" onClick={this.clickCancel}>
                                            배차취소
                                        </button>
                                    )}
                                    {/* <button type="button" className="btn_02 green">
                                        그린버튼
                                    </button>
                                    <button type="button" className="btn_02 red">
                                        레드버튼
                                    </button> */}
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="table_board_box">
                                    <table className="tbl_board small list bg">
                                        <colgroup>
                                            <col />
                                            <col />
                                            <col />
                                            <col width="90" />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th
                                                    onClick={e => {
                                                        const { items } = this.state;
                                                        const itemsCheck = items.filter(x => x.check);
                                                        if (itemsCheck.length === items.length) {
                                                            items.map(x => (x.check = false));
                                                        } else {
                                                            items.map(x => (x.check = true));
                                                        }
                                                        this.setState({ items });
                                                    }}
                                                >
                                                    선택
                                                </th>
                                                <th>ID</th>
                                                {this.role === 'ADMIN' && <th>지역사무소</th>}
                                                <th>검사예정일시</th>
                                                <th>건물명</th>
                                                <th>건물주소</th>
                                                <th>고객안내번호</th>
                                                <th>검사종류</th>
                                                <th>검사대수</th>
                                                {/* <th>검사신청자ID</th> */}
                                                {/* <th>
                                                    승강기형식
                                                    <br />
                                                    (원장기준)
                                                </th> */}
                                                <th>
                                                    최대시험하중
                                                    <br />
                                                    (원장기준)
                                                </th>
                                                {/* <th>
                                                    대표제조업체명
                                                    <br />
                                                    (신청서기준)
                                                </th> */}
                                                <th>대표유지 관리업체</th>
                                                <th>
                                                    최대시험하중 <br />
                                                    (신청서기준)
                                                </th>
                                                <th>검사자</th>
                                                <th>검사자연락처</th>
                                                <th>분동기사</th>
                                                <th>분동기사연락처</th>
                                                <th>분동차량번호</th>
                                                <th>승강기고유번호</th>
                                                {/* <th>FM여부</th> */}
                                                {this.role === 'ADMIN' && <th>지사선택</th>}
                                                <th>기사선택</th>

                                                <th>단가</th>
                                                <th>기사금액</th>
                                                {this.role === 'ADMIN' && <th>결제</th>}
                                                {this.role === 'ADMIN' && <th></th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {items.map(x => {
                                                let driverColor = 'bgGray';
                                                if (x.driverId) {
                                                    if (x.confirmDriver === 'Y') {
                                                        driverColor = 'bgBlue';
                                                    } else {
                                                        driverColor = 'bgGreen';
                                                    }
                                                }
                                                if (x.complete === 'Y') {
                                                    driverColor = 'bgBlack';
                                                }

                                                return (
                                                    <tr>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                class="saveCheck"
                                                                checked={x.check}
                                                                onChange={e => {
                                                                    x.check = !x.check;
                                                                    this.setState({});
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="bgGray">{x.id}</td>
                                                        {this.role === 'ADMIN' && <td>{x.inspct_instt_nm}</td>}
                                                        <td>{moment(x.inspct_dt).format('YYYY-MM-DD HH:mm')}</td>
                                                        <td>{x.buld_nm}</td>
                                                        <td>{x.address}</td>
                                                        <td>{x.cstmr_guidance_no}</td>
                                                        <td>{x.inspct_kind_nm}</td>
                                                        <td>{this.selectNumber(x)}</td>
                                                        {/* <td>{x.reqst_id}</td> */}
                                                        {/* <td>{x.ledg_elvtr_form}</td> */}
                                                        <td>{x.ledg_live_load}</td>
                                                        {/* <td>{x.reqst_mnfctur_cpny_info}</td> */}
                                                        {/* <td>{x.ledg_mnfctur_cpny_info}</td> */}
                                                        <td>{x.ledg_mnt_cpny_info}</td>
                                                        <td>{x.reqst_live_load}</td>
                                                        {/* <td>{x.main_inspctr_nm}</td>
                                                    <td>{x.main_inspctr_tel}</td>
                                                    <td>{x.bal_engr_nm}</td>
                                                    <td>{x.bal_engr_mobile_no}</td>
                                                    <td>{x.bal_car_no}</td> */}
                                                        <td>{x.manager1 && x.manager1.name}</td>
                                                        <td>{x.manager1 && x.manager1.phone}</td>
                                                        <td>{x.driver && x.driver.name}</td>
                                                        <td>{x.driver && x.driver.phone}</td>
                                                        <td>{x.driver && x.driver.carNumber}</td>
                                                        <td>{x.elevatorId}</td>
                                                        {/* <td>{x.fm > 0 ? 'Y' : 'N'}</td> */}
                                                        {this.role === 'ADMIN' && (
                                                            <td className={x.branchId ? 'bgGreen' : 'bgGray'}>{this.selectorBranch(x)}</td>
                                                        )}
                                                        <td className={driverColor}>{this.selectorDriver(x)}</td>

                                                        {this.role === 'ADMIN' ? (
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    value={x.price}
                                                                    style={{ width: 100 }}
                                                                    onChange={e => {
                                                                        x.price = e.target.value;
                                                                        this.setState({});
                                                                    }}
                                                                    onBlur={e => {
                                                                        UpdateAll(this, [{ id: x.id, price: x.price }]);
                                                                    }}
                                                                />
                                                            </td>
                                                        ) : (
                                                            <td>{x.branchPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                        )}
                                                        {this.role === 'ADMIN' ? (
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    value={x.branchPrice}
                                                                    style={{ width: 100 }}
                                                                    onChange={e => {
                                                                        x.branchPrice = e.target.value;
                                                                        this.setState({});
                                                                    }}
                                                                    onBlur={e => {
                                                                        UpdateAll(this, [{ id: x.id, branchPrice: x.branchPrice }]);
                                                                    }}
                                                                />
                                                            </td>
                                                        ) : (
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    value={x.driverPrice}
                                                                    style={{ width: 100 }}
                                                                    onChange={e => {
                                                                        x.driverPrice = e.target.value;
                                                                        this.setState({});
                                                                    }}
                                                                    onBlur={e => {
                                                                        UpdateAll(this, [{ id: x.id, driverPrice: x.driverPrice }]);
                                                                    }}
                                                                />
                                                            </td>
                                                        )}

                                                        {/* {this.role === 'ADMIN' && <td>{x.pay > 0 ? 'Y' : 'N'}</td>} */}
                                                        {this.role === 'ADMIN' && <td>{this.selectorPay(x)}</td>}

                                                        {this.role === 'ADMIN' && (
                                                            <td>
                                                                {/* {x.complete !== 'Y' && ( */}
                                                                <Button
                                                                    variant="success"
                                                                    onClick={e => {
                                                                        window.location = '/a/batcha/edit/' + x.id;
                                                                    }}
                                                                >
                                                                    수정
                                                                </Button>
                                                                {/* )} */}
                                                            </td>
                                                        )}
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="gab40"></div>

                                <div className="textRight">
                                    <PageBar nowPage={Number(this.state.search.page)} totalPage={this.state.totalPages} reload={this.reloadList} />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default List;
